<div class="modal model-base" [class.active]="isActive"> 
    <div class="modal-content">
        <div class="modal-header"> 
            <button class="close" (click)="onReject()" type="button">×</button>
            <h3>&nbsp;<ng-content *ngIf="!disableHeader" select="span[role=header]"></ng-content>
            </h3>
        </div>
        <div class="modal-body">
            <ng-content select="div[role=body]"></ng-content>
        </div>
        <div class="modal-footer" *ngIf="!disableFooter">
            <ng-content select="div[role=footer]"></ng-content>
                <input name="accept" type="submit" class="btn-yes txt-font" style="color: white !important;
                " value="{{acceptText}}" (click)="onAccept()"
                    *ngIf="isActive && acceptText?.length > 0">
                <input name="reject" type="submit" class="txt-font btn-no" value="{{rejectText}}" (click)="onReject()"
                    *ngIf="isActive && rejectText?.length > 0">
        </div>
    </div>
</div>